<loading-component>
  <div slot="end" class="loading__title">{{ 'REDSYS_PROCESSING_REDIRECT.TITLE' | translate }}</div>
  <div slot="end" class="loading__description">{{ 'REDSYS_PROCESSING_REDIRECT.DESCRIPTION' | translate }}</div>
</loading-component>